export enum MembershipTier {
  ONE = 'ONE',
  PEAK = 'PEAK',
  LIFE = 'LIFE',
}

export enum PlanTypes {
  ANNUAL = 'annual',
  TWO_YEAR = 'twoYear',
  FAMILY = 'family',
  TRIAL = 'trial', //subscriptionType on variants is lowercase
}

export enum DeviceGeneration {
  HARVARD = 'HARVARD',
  GOOSE = 'GOOSE',
  MAVERICK = 'MAVERICK',
}

// Chronologically ordered list of generations using the DeviceGeneration enum
export const GENERATION_ORDER: DeviceGeneration[] = [
  DeviceGeneration.HARVARD,
  DeviceGeneration.GOOSE,
  DeviceGeneration.MAVERICK,
];
